module.exports = __webpack_public_path__ + "static/at-4c2bc0f8ab63079ffa2867cb4d37342f.png";